<template>
  <v-row justify="center">
    <h1 class="text-center">Supplier Qualification Questionnaire</h1>
    <div class="mb-10">
      <p class="text-left mt-8 ml-2">
        Please ensure that all sections of this questionnaire are completed, and
        all relevant information is provided where requested. The information
        you provide will be used to assess your organisation's ability to
        deliver goods and/or services in accordance with
        <span>{{ formattedTLC }}</span> expectations.
      </p>
    </div>
  </v-row>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "QuestionnaireHeader",

  props: {
    tlc: { type: String, required: true },
  },

  computed: {
    formattedTLC(): string {
      return this.tlc?.length > 0 && this.tlc[this.tlc.length - 1] == "s"
        ? `${this.tlc}'`
        : `${this.tlc}'s`;
    },
  },
});
</script>
